"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stefan = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const DrawCards_1 = require("../../deferredActions/DrawCards");
const SelectCard_1 = require("../../inputs/SelectCard");
const LogHelper_1 = require("../../LogHelper");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const Size_1 = require("../render/Size");
class Stefan extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.STEFAN,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L19',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.opgArrow().text('ACTIVATE THE BELOW ABILITY');
                    b.br;
                    b.text('PAY').megacredits(0).multiplier.colon().text('X').cards(1).text('(MAX 5)', Size_1.Size.SMALL);
                    b.br;
                    b.text('SELL').cards(1).colon().megacredits(3);
                }),
                description: 'Once per game, pay X M€ equal to the current generation number to draw X cards (max 5), then sell ANY number of cards from hand for 3 M€ each.',
            },
        });
        this.isDisabled = false;
    }
    play() {
        return undefined;
    }
    canAct(player) {
        const cost = player.game.generation;
        return player.canAfford(cost) && this.isDisabled === false;
    }
    action(player) {
        const game = player.game;
        const cost = game.generation;
        const cardsDrawnQty = Math.min(game.generation, 5);
        game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, cost, { title: 'Select how to pay for action' }));
        game.defer(DrawCards_1.DrawCards.keepAll(player, cardsDrawnQty));
        return new SelectCard_1.SelectCard('Sell patents', 'Sell', player.cardsInHand, (foundCards) => {
            player.megaCredits += foundCards.length * 3;
            foundCards.forEach((card) => {
                for (let i = 0; i < player.cardsInHand.length; i++) {
                    if (player.cardsInHand[i].name === card.name) {
                        player.cardsInHand.splice(i, 1);
                        break;
                    }
                }
                game.dealer.discard(card);
            });
            game.log('${0} sold ${1} patents', (b) => b.player(player).number(foundCards.length));
            LogHelper_1.LogHelper.logDrawnCards(player, foundCards.map((card) => card.name), true, DrawCards_1.LogType.SOLD);
            this.isDisabled = true;
            return undefined;
        }, {
            max: player.cardsInHand.length + cardsDrawnQty,
        });
    }
}
exports.Stefan = Stefan;
//# sourceMappingURL=Stefan.js.map